import { render, staticRenderFns } from "./ManageBuildingsV2Page.vue?vue&type=template&id=0e4162cd&scoped=true&"
import script from "./ManageBuildingsV2Page.vue?vue&type=script&lang=js&"
export * from "./ManageBuildingsV2Page.vue?vue&type=script&lang=js&"
import style0 from "./ManageBuildingsV2Page.vue?vue&type=style&index=0&id=0e4162cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4162cd",
  null
  
)

export default component.exports